import { defineStore } from 'pinia'

export const useTableStore = defineStore('tableStore', {
  state: () => ({
    financeBuildings: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'totalCredits' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    ships: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'shipName' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        selectedAction: '' as string,
        selectedType: '' as string,
        selectedFleet: '0' as string,
        nameSearch: '' as string,
        selectedGroup: 0 as number
      }
    },
    mapShips: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'shipName' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        selectedAction: '' as string,
        selectedType: '' as string,
        selectedFleet: '0' as string,
        nameSearch: '' as string
      }
    },
    fleets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    routes: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    mapFleets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    mapFleetShips: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'shipName' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        selectedType: '' as string,
        nameSearch: '' as string
      }
    },
    leaderboard: {
      page: 0 as number,
      rowsPerPage: 1000 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'planets' as string,
      sortDirection: 'desc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    planets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'planetName' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string,
        selectedCompatible: '' as string,
        noProduction: false as boolean,
        selectedGroup: 0 as number
      }
    },
    shipDesigns: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    mapCoords: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'eta' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string,
        selectedCompatible: '' as string,
        selectedPlayer: '' as string
      }
    },
    mapCoordsFleets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'eta' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        selectedPlayer: '' as string
      }
    },
    mapCoordsEnemyFleets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'eta' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        selectedPlayer: '' as string
      }
    },
    shipGroups: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as [],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    alliances: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    allianceMembers: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {
        nameSearch: '' as string
      }
    },
    terraformingPlanets: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'planetName' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    ringworldConversionStars: {
      page: 0 as number,
      rowsPerPage: 25 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    battleSimulatorAttacking: {
      page: 0 as number,
      rowsPerPage: 100 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    },
    battleSimulatorDefending: {
      page: 0 as number,
      rowsPerPage: 100 as number,
      totalRows: 0 as number,
      totalFilteredRows: 0 as number,
      visibleRows: 0 as number,
      selectedRowIds: [] as number[],
      selectedAll: false as boolean,
      sortColumn: 'name' as string,
      sortDirection: 'asc' as string,
      singleSelectedId: 0 as number,
      filters: {}
    }
  }),
  getters: {},
  actions: {},
  persist: {
    key: 'tableStore',
    storage: localStorage,
    serializer: {
      serialize: (state) => {
        // Deep clone using JSON
        const cloned = JSON.parse(JSON.stringify(state))

        // Remove selectedRowIds and selectedAll from each top-level entry
        for (const key in cloned) {
          if (cloned[key] && typeof cloned[key] === 'object') {
            delete cloned[key].selectedRowIds
            delete cloned[key].selectedAll
            delete cloned[key].page
          }
        }

        return JSON.stringify(cloned)
      },
      deserialize: (value) => JSON.parse(value)
    }
  }
})
